import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import parse from 'html-react-parser';
import '../css/highlights.css';
import Presentation from './Presentation';

export default function Highlights(props) {
  const imgCDNURL = process.env.REACT_APP_ABOUT203KLOAN_CDN_URL;

  return (
    <div className="fha203KContainer pt-mobile-2">
      <img src={imgCDNURL + "5dots-group.png"} className="dots-group-left img-fluid" alt="5dots-group" />
      <img src={imgCDNURL + "ellipse-desktop-left.png"} className="ellipse-group-left img-fluid" alt="ellipse-desktop-left" />
      <img src={imgCDNURL + "5dots-group.png"} className="dots-group-right img-fluid" alt="5dots-group" />
      <img src={imgCDNURL + "ellipse-desktop-right.png"} className="ellipse-group-right img-fluid" alt="ellipse-desktop-right" />
      <Container className="container-pad">
        <Row className="align-correct">
          <Col sm={12} className="mb-3 text-justify">
            <h3 className="fha203KHeading">FHA 203K</h3>
          </Col>
          <Col sm={12} className="text-justify">
            {props.siteData && 
              <h5 className="mb-4 highlights-detail">
                {parse(props.siteData.paragraph)}
              </h5>
            }
            <h5 className="mb-4 highlights-detail">
              The 203k program is a great way to finance both the purchase (or refinancing) of a house and 
              the cost of its rehabilitation through a single mortgage or to finance the rehabilitation of 
              their existing home. The key word here is "renovation" - you can use this program to repair 
              deficiencies, make modifications that increase accessibility, improve energy efficiency, and 
              more.
            </h5>
            <h5 className="mb-4 highlights-detail">
              The expenses associated with home improvement and repair efforts are added to the total loan 
              amount that you select to borrow and can be paid off over a period of years as you pay off the 
              monthly payments associated with your mortgage.
            </h5>
            <h5 className="mb-4 highlights-detail-bold">
              There are two types of FHA 203(k) loans for you to choose from: a Limited 203(k) loan and a 
              standard 203(k) loan.
            </h5>
          </Col>
        </Row>
        <Row>
          <Col sm={12} className="pt-3 mb-3 text-justify">
            <div className="subHeadingContainer">
              <div className="subHeadingTitleContainer">
                <h4 className="subHeadingTitle">Limited 203(k) Loan</h4>
              </div>
              <hr className="subHeadingContainerBorder"/>
            </div>
          </Col>
          <Col sm={12} className="text-justify">
            <h5 className="mb-4 highlights-detail">
              A Limited 203(k) loan is frequently utilized for homes that require fewer repairs. It 
              provides home buyers or homeowners with a maximum of $35,000 for renovations. Repairs 
              allowed under this program are Replacement of roof shingles, Cosmetic Repairs such as 
              financing purchase/installation of new appliances, patching holes, replacing doors, 
              painting, lead paint abatement, new counters, cabinets, windows, carpet, 
              repair/installation of HVAC, weatherization. minor repair of termite damage etc.
            </h5>
            <h5 className="mb-4 highlights-detail ">
              <span className="highlights-detail-bold">Note:</span> Structural repairs and additions are not allowed Under Limited 203(K) and must be 
              a Standard 203(K) if structural repairs are required.
            </h5>
          </Col>
        </Row>
        <Row>
          <Col sm={12} className="pt-3 mb-3 text-justify">
            <div className="subHeadingContainer">
              <div className="subHeadingTitleContainer">
                <h4 className="subHeadingTitle">Standard 203(k) Loan</h4>
              </div>
              <hr className="subHeadingContainerBorder"/>
            </div>
          </Col>
          <Col sm={12} className="text-justify">
            <h5 className="mb-4 highlights-detail">
              A standard 203(k) loan is typically used for major structural repairs exceeding $35,000. 
              Renovations must cost a minimum of $5,000. This program includes roof replacement that 
              involves re-framing or structural changes, health and safety hazard mitigation, landscaping 
              required to mitigate drainage or erosion issues, aesthetic landscaping when appraiser 
              verifies that the value increases the dollar-for-dollar cost, sidewalk/driveway repair 
              necessary for home access, major repair of termite damage, drywall/insulation replacement, 
              most repairs which require permits, finishing basements. Egress window wells for basements 
              will be admissible.
            </h5>
          </Col>
        </Row>
        <Row className="pt-3 mb-3 keyDetailsContainerBox">
          <Col sm={12} className="pt-3 keyDetailsContainer">
            <Container>
              <Row>
                <Col sm={12} className="mb-3">
                  <h4 className="keyDetailsTitle">Eligible properties under FHA 203(k) program are:</h4>
                </Col>
              </Row>
              <Row>
                <Col lg={6} sm={12}>
                  <div className="d-flex mb-3">
                    <div className="col-1"><img src={imgCDNURL + "pointer-icon.png"} className="img-fluid" alt="checkpoint-1" /></div>
                    <div className="col-11 pad-sm-3"><h5 className="keyDetailsPointers">1-4 Unit Properties</h5></div>
                  </div>
                  <div className="d-flex mb-3">
                    <div className="col-1"><img src={imgCDNURL + "pointer-icon.png"} className="img-fluid" alt="checkpoint-2" /></div>
                    <div className="col-11 pad-sm-3"><h5 className="keyDetailsPointers">PUDs</h5></div>
                  </div>
                  <div className="d-flex mb-3">
                    <div className="col-1"><img src={imgCDNURL + "pointer-icon.png"} className="img-fluid" alt="checkpoint-3" /></div>
                    <div className="col-11 pad-sm-3"><h5 className="keyDetailsPointers">Condominium (in FHA approved projects) and site-condos</h5></div>
                  </div>
                </Col>
                <Col lg={6} sm={12}>
                  <div className="d-flex mb-3">
                    <div className="col-1"><img src={imgCDNURL + "pointer-icon.png"} className="img-fluid" alt="checkpoint-4" /></div>
                    <div className="col-11 pad-sm-3"><h5 className="keyDetailsPointers">Manufactured Housing (Multi-Wide and Single-Wide)</h5></div>
                  </div>
                  <div className="d-flex mb-3">
                    <div className="col-1"><img src={imgCDNURL + "pointer-icon.png"} className="img-fluid" alt="checkpoint-5" /></div>
                    <div className="col-11 pad-sm-3"><h5 className="keyDetailsPointers">Manufactured Condo</h5></div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Presentation />
        </Row>
        <Row>
          <Col sm={12} className="text-justify">
            <h5 className="mb-4 highlights-detail ">
              <span className="highlights-detail-bold">Note:</span> Manufactured Home must be constructed after June 15, 1976.
            </h5>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
